"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _components2 = require('components');

require('./ModifierModalView.less');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ModifierModalView: {
        displayName: 'ModifierModalView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/ModifierModal/default/ModifierModalView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ModifierModalView = _wrapComponent('ModifierModalView')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        translations: state.lang
    };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ModifierModalView, _Component);

    function ModifierModalView(props) {
        (0, _classCallCheck3.default)(this, ModifierModalView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModifierModalView.__proto__ || (0, _getPrototypeOf2.default)(ModifierModalView)).call(this, props));

        _this.renderModSelect = function () {
            return _react3.default.createElement(
                'div',
                { className: 'no-margin col-xs-12 col-sn-12 col-md-12' },
                _this.props.product_detail.modifier[0] !== undefined ? _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                    _this.props.product_detail.modifier[0].name,
                    _react3.default.createElement(
                        'select',
                        { className: 'form-control', onChange: _this.props.handleSelect0,
                            value: _this.props.modValuesId0 },
                        _react3.default.createElement(
                            'option',
                            { value: 'all' },
                            _this.props.lang['store.common.choose']
                        ),
                        _this.props.modValues0.map(function (item, i) {
                            return _react3.default.createElement(
                                'option',
                                { key: item.id, value: item.id },
                                '' + item.name
                            );
                        })
                    )
                ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
                _this.props.product_detail.modifier[1] !== undefined ? _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                    _this.props.product_detail.modifier[1].name,
                    _react3.default.createElement(
                        'select',
                        { className: 'form-control', onChange: _this.props.handleSelect1,
                            value: _this.props.modValuesId1 },
                        _react3.default.createElement(
                            'option',
                            { value: 'all' },
                            _this.props.lang['store.common.choose']
                        ),
                        _this.props.modValues1.map(function (item, i) {
                            return _react3.default.createElement(
                                'option',
                                { key: item.id, value: item.id },
                                '' + item.name
                            );
                        })
                    )
                ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
                _this.props.product_detail.modifier[2] !== undefined ? _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                    _this.props.product_detail.modifier[2].name,
                    _react3.default.createElement(
                        'select',
                        { className: 'form-control', onChange: _this.props.handleSelect2,
                            value: _this.props.modValuesId2 },
                        _react3.default.createElement(
                            'option',
                            { value: 'all' },
                            _this.props.lang['store.common.choose']
                        ),
                        _this.props.modValues2.map(function (item, i) {
                            return _react3.default.createElement(
                                'option',
                                { key: item.id, value: item.id },
                                '' + item.name
                            );
                        })
                    )
                ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' })
            );
        };

        _this.renderNestedOffers = function () {
            var weight = 0;
            var childWeight = 0;
            return _react3.default.createElement(
                'div',
                { className: 'no-margin col-xs-12 col-sn-12 col-md-12', style: { paddingTop: '10px' } },
                _react3.default.createElement(
                    'table',
                    { style: { width: '100%' } },
                    _react3.default.createElement(
                        'tbody',
                        null,
                        _react3.default.createElement(
                            'tr',
                            { style: { background: '#E0E0E0' } },
                            _react3.default.createElement(
                                'th',
                                { style: { width: '5%', padding: '5px' } },
                                '#'
                            ),
                            _react3.default.createElement(
                                'th',
                                { style: { width: '70%', padding: '5px' } },
                                _this.props.lang['store.short_description.component_title']
                            ),
                            _react3.default.createElement(
                                'th',
                                { style: { width: '15%', padding: '5px', textAlign: 'center' } },
                                _this.props.lang['store.short_description.quantity']
                            ),
                            _react3.default.createElement('th', { style: { width: '10%' } })
                        ),
                        _this.props.product_detail.nestedOffers.map(function (item, index) {
                            weight = item.quantity;
                            if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0 && item.quantity > 0) {
                                weight = item.weight * item.quantity;
                                weight = weight.toFixed(3);
                                if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
                                    weight = item.weight * 1;
                                }
                                if (item.weight < 0.1 && item.quantity < 0.1) {
                                    weight = item.weight * 1;
                                }
                            }
                            // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
                            var maxValue = item.hasOwnProperty('quantity_max') && item.quantity_max > 0 ? +item.quantity_max : ModifierModalView.MaxValue;
                            var minValue = item.hasOwnProperty('quantity_min') && item.quantity_min > 0 ? +item.quantity_min : 0;
                            // определяем шаг изменения
                            var step = item.stepQuantity ? item.stepQuantity : 1;
                            var classPlus = item.quantity + step > maxValue ? 'plus _disabled' : 'plus';
                            var classMinus = item.quantity - step < minValue ? 'minus _disabled' : 'minus';
                            if (item.quantity > 0 && item.is_quantity_change !== true && item.childOffer.type_id !== 5) {
                                return _react3.default.createElement(
                                    'tr',
                                    null,
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '5%', padding: '5px' } },
                                        _react3.default.createElement(
                                            'b',
                                            null,
                                            index + 1
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '70%', padding: '5px' } },
                                        _react3.default.createElement(
                                            'b',
                                            null,
                                            item.childOffer.name,
                                            ' ',
                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { colSpan: 2, style: {
                                                width: '25%',
                                                padding: '5px',
                                                textAlign: 'center'
                                            } },
                                        _react3.default.createElement(
                                            'b',
                                            null,
                                            weight,
                                            ' ',
                                            _this.props.translations[item.childOffer.unit.title_lang_data]
                                        )
                                    )
                                );
                            } else if (item.is_quantity_change && item.childOffer.type_id !== 5) {
                                return _react3.default.createElement(
                                    'tr',
                                    null,
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '5%', padding: '5px' } },
                                        _react3.default.createElement(
                                            'b',
                                            null,
                                            index + 1
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '70%', padding: '5px' } },
                                        _react3.default.createElement(
                                            'b',
                                            null,
                                            item.childOffer.name,
                                            ' ',
                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: {
                                                width: '15%',
                                                padding: '5px',
                                                textAlign: 'center'
                                            } },
                                        _react3.default.createElement(
                                            'div',
                                            { style: { transform: 'scale(0.9 , 0.9)' }, className: 'le-quantity inline' },
                                            _react3.default.createElement('a', { className: classMinus, onClick: function onClick(e) {
                                                    _this.props.onClickMinusNested(e, item.id);
                                                } }),
                                            _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: weight, style: { width: '100px' } }),
                                            _react3.default.createElement('a', { className: classPlus, onClick: function onClick(e) {
                                                    _this.props.onClickPlusNested(e, item.id);
                                                } })
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '10%' } },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
                                            _react3.default.createElement(
                                                'b',
                                                null,
                                                _this.props.translations[item.childOffer.unit.title_lang_data]
                                            )
                                        )
                                    )
                                );
                            } else if (item.is_quantity_change && item.childOffer.type_id === 5) {
                                return _react3.default.createElement(
                                    'tr',
                                    null,
                                    _react3.default.createElement(
                                        'td',
                                        { colSpan: '4' },
                                        _react3.default.createElement(
                                            'table',
                                            { width: '100%' },
                                            _react3.default.createElement(
                                                'tbody',
                                                null,
                                                _react3.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react3.default.createElement(
                                                        'td',
                                                        { style: { width: '5%', padding: '5px' } },
                                                        _react3.default.createElement(
                                                            'b',
                                                            null,
                                                            index + 1
                                                        )
                                                    ),
                                                    _react3.default.createElement(
                                                        'td',
                                                        { style: { width: '70%', padding: '5px', textAlign: 'left' } },
                                                        _react3.default.createElement(
                                                            'b',
                                                            null,
                                                            item.childOffer.name
                                                        )
                                                    ),
                                                    _react3.default.createElement('td', { colSpan: '2', style: {
                                                            width: '25%',
                                                            padding: '5px',
                                                            textAlign: 'center'
                                                        } })
                                                ),
                                                _react3.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react3.default.createElement(
                                                        'td',
                                                        { colSpan: '4' },
                                                        _react3.default.createElement(
                                                            'div',
                                                            { className: 'no-margin col-xs-12 col-sn-12 col-md-12' },
                                                            item.childOffer.modifier[0] !== undefined ? _react3.default.createElement(
                                                                'div',
                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                                                                item.childOffer.modifier[0].name,
                                                                _react3.default.createElement(
                                                                    'select',
                                                                    { className: 'form-control', onChange: function onChange(e) {
                                                                            _this.props.handleSelectChildOffer(e, 0, item.id);
                                                                        },
                                                                        value: item.valuesMods[0] },
                                                                    _react3.default.createElement(
                                                                        'option',
                                                                        { value: 'all' },
                                                                        _this.props.lang['store.common.choose']
                                                                    ),
                                                                    item.childOffer.modifier[0].values.map(function (value, i) {
                                                                        return _react3.default.createElement(
                                                                            'option',
                                                                            { key: value.id, value: value.id },
                                                                            '' + value.name
                                                                        );
                                                                    })
                                                                )
                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
                                                            item.childOffer.modifier[1] !== undefined ? _react3.default.createElement(
                                                                'div',
                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                                                                item.childOffer.modifier[1].name,
                                                                _react3.default.createElement(
                                                                    'select',
                                                                    { className: 'form-control', onChange: function onChange(e) {
                                                                            _this.props.handleSelectChildOffer(e, 1, item.id);
                                                                        },
                                                                        value: item.valuesMods[1] },
                                                                    _react3.default.createElement(
                                                                        'option',
                                                                        { value: 'all' },
                                                                        _this.props.lang['store.common.choose']
                                                                    ),
                                                                    item.childOffer.modifier[1].values.map(function (value, i) {
                                                                        return _react3.default.createElement(
                                                                            'option',
                                                                            { key: value.id, value: value.id },
                                                                            '' + value.name
                                                                        );
                                                                    })
                                                                )
                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
                                                            item.childOffer.modifier[2] !== undefined ? _react3.default.createElement(
                                                                'div',
                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                                                                item.childOffer.modifier[2].name,
                                                                _react3.default.createElement(
                                                                    'select',
                                                                    { className: 'form-control', onChange: function onChange(e) {
                                                                            _this.props.handleSelectChildOffer(e, 2, item.id);
                                                                        },
                                                                        value: item.childOffer.modValuesId2 },
                                                                    _react3.default.createElement(
                                                                        'option',
                                                                        { value: 'all' },
                                                                        _this.props.lang['store.common.choose']
                                                                    ),
                                                                    item.childOffer.modifier[2].values.map(function (value, i) {
                                                                        return _react3.default.createElement(
                                                                            'option',
                                                                            { key: value.id, value: value.id },
                                                                            '' + value.name
                                                                        );
                                                                    })
                                                                )
                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' })
                                                        )
                                                    )
                                                ),
                                                item.childOffer.nestedOffers.map(function (childItem, childIndex) {
                                                    childWeight = childItem.quantity;
                                                    if ((childItem.childOffer.unit.slug === 'kg' || childItem.childOffer.unit.slug === 'mg') && childItem.weight && childItem.weight > 0 && childItem.quantity > 0) {
                                                        childWeight = childItem.weight * childItem.quantity;
                                                        childWeight = childWeight.toFixed(3);
                                                        if (childItem.weight < 0.01 && childItem.quantity < 1 || childItem.weight < 1 && childItem.quantity < 0.01) {
                                                            childWeight = childItem.weight * 1;
                                                        }
                                                        if (childItem.weight < 0.1 && childItem.quantity < 0.1) {
                                                            childWeight = childItem.weight * 1;
                                                        }
                                                    }
                                                    if (childItem.quantity > 0 && childItem.is_quantity_change !== true) {
                                                        return _react3.default.createElement(
                                                            'tr',
                                                            null,
                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: { width: '70%', padding: '5px' } },
                                                                childItem.childOffer.name,
                                                                ' ',
                                                                childItem.childOffer.modOption ? '(' + childItem.childOffer.modOption.name + ')' : ''
                                                            ),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { colSpan: '2', style: {
                                                                        width: '25%',
                                                                        padding: '5px',
                                                                        textAlign: 'center'
                                                                    } },
                                                                childWeight,
                                                                ' ',
                                                                _this.props.translations[childItem.childOffer.unit.title_lang_data]
                                                            )
                                                        );
                                                    } else if (childItem.is_quantity_change === true) {
                                                        // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
                                                        var _maxValue = childItem.hasOwnProperty('quantity_max') && childItem.quantity_max > 0 ? +childItem.quantity_max : ModifierModalView.MaxValue;
                                                        var _minValue = childItem.hasOwnProperty('quantity_min') && childItem.quantity_min > 0 ? +childItem.quantity_min : 0;
                                                        // определяем шаг изменения
                                                        var _step = childItem.stepQuantity ? childItem.stepQuantity : 1;
                                                        var _classPlus = _step + childItem.quantity > _maxValue ? 'plus _disabled' : 'plus';
                                                        var _classMinus = childItem.quantity - _step < _minValue ? 'minus _disabled' : 'minus';
                                                        return _react3.default.createElement(
                                                            'tr',
                                                            null,
                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: { width: '70%', padding: '5px' } },
                                                                childItem.childOffer.name,
                                                                ' ',
                                                                childItem.modOption ? '(' + childItem.modOption.name + ')' : ''
                                                            ),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: {
                                                                        width: '15%',
                                                                        padding: '5px',
                                                                        textAlign: 'center'
                                                                    } },
                                                                _react3.default.createElement(
                                                                    'div',
                                                                    { style: { transform: 'scale(0.8 , 0.8)' }, className: 'le-quantity inline' },
                                                                    _react3.default.createElement('a', { className: _classMinus, onClick: function onClick(e) {
                                                                            _this.props.onClickMinusChildNested(e, item.id, childItem.id);
                                                                        } }),
                                                                    _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: childWeight, style: { width: '100px' } }),
                                                                    _react3.default.createElement('a', { className: _classPlus, onClick: function onClick(e) {
                                                                            _this.props.onClickPlusChildNested(e, item.id, childItem.id);
                                                                        } })
                                                                )
                                                            ),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: { width: '10%' } },
                                                                _react3.default.createElement(
                                                                    'div',
                                                                    { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
                                                                    _react3.default.createElement(
                                                                        'b',
                                                                        null,
                                                                        _this.props.translations[childItem.childOffer.unit.title_lang_data]
                                                                    )
                                                                )
                                                            )
                                                        );
                                                    }
                                                }),
                                                _react3.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react3.default.createElement('td', null),
                                                    _react3.default.createElement('td', null),
                                                    _react3.default.createElement(
                                                        'td',
                                                        { style: {
                                                                padding: '5px',
                                                                textAlign: 'center'
                                                            } },
                                                        _react3.default.createElement(
                                                            'div',
                                                            { style: { transform: 'scale(0.9 , 0.9)' }, className: 'le-quantity inline' },
                                                            _react3.default.createElement('a', { className: classMinus, onClick: function onClick(e) {
                                                                    _this.props.onClickMinusNested(e, item.id);
                                                                } }),
                                                            _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text',
                                                                value: weight, style: { width: '100px' } }),
                                                            _react3.default.createElement('a', { className: classPlus, onClick: function onClick(e) {
                                                                    _this.props.onClickPlusNested(e, item.id);
                                                                } })
                                                        ),
                                                        _react3.default.createElement(
                                                            'div',
                                                            { className: 'inline',
                                                                style: { paddingTop: '10px', paddingLeft: '10px' } },
                                                            _this.props.translations[item.childOffer.unit.title_lang_data]
                                                        )
                                                    ),
                                                    _react3.default.createElement('td', null)
                                                )
                                            )
                                        )
                                    )
                                );
                            } else if (item.quantity > 0 && item.is_quantity_change !== true && item.childOffer.type_id === 5) {
                                return _react3.default.createElement(
                                    'tr',
                                    null,
                                    _react3.default.createElement(
                                        'td',
                                        { colSpan: '4' },
                                        _react3.default.createElement(
                                            'table',
                                            { width: '100%' },
                                            _react3.default.createElement(
                                                'tbody',
                                                null,
                                                _react3.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react3.default.createElement(
                                                        'td',
                                                        { style: { width: '5%', padding: '5px' } },
                                                        _react3.default.createElement(
                                                            'b',
                                                            null,
                                                            index + 1
                                                        )
                                                    ),
                                                    _react3.default.createElement(
                                                        'td',
                                                        { style: { width: '70%', padding: '5px', textAlign: 'left' } },
                                                        _react3.default.createElement(
                                                            'b',
                                                            null,
                                                            item.childOffer.name
                                                        )
                                                    ),
                                                    _react3.default.createElement('td', { colSpan: '2', style: {
                                                            width: '25%',
                                                            padding: '5px',
                                                            textAlign: 'center'
                                                        } })
                                                ),
                                                _react3.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react3.default.createElement(
                                                        'td',
                                                        { colSpan: '4' },
                                                        _react3.default.createElement(
                                                            'div',
                                                            { className: 'no-margin col-xs-12 col-sn-12 col-md-12' },
                                                            item.childOffer.modifier[0] !== undefined ? _react3.default.createElement(
                                                                'div',
                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                                                                item.childOffer.modifier[0].name,
                                                                _react3.default.createElement(
                                                                    'select',
                                                                    { className: 'form-control', onChange: function onChange(e) {
                                                                            _this.props.handleSelectChildOffer(e, 0, item.id);
                                                                        },
                                                                        value: item.valuesMods[0] },
                                                                    _react3.default.createElement(
                                                                        'option',
                                                                        { value: 'all' },
                                                                        _this.props.lang['store.common.choose']
                                                                    ),
                                                                    item.childOffer.modifier[0].values.map(function (value, i) {
                                                                        return _react3.default.createElement(
                                                                            'option',
                                                                            { key: value.id, value: value.id },
                                                                            '' + value.name
                                                                        );
                                                                    })
                                                                )
                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
                                                            item.childOffer.modifier[1] !== undefined ? _react3.default.createElement(
                                                                'div',
                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                                                                item.childOffer.modifier[1].name,
                                                                _react3.default.createElement(
                                                                    'select',
                                                                    { className: 'form-control', onChange: function onChange(e) {
                                                                            _this.props.handleSelectChildOffer(e, 1, item.id);
                                                                        },
                                                                        value: item.valuesMods[1] },
                                                                    _react3.default.createElement(
                                                                        'option',
                                                                        { value: 'all' },
                                                                        _this.props.lang['store.common.choose']
                                                                    ),
                                                                    item.childOffer.modifier[1].values.map(function (value, i) {
                                                                        return _react3.default.createElement(
                                                                            'option',
                                                                            { key: value.id, value: value.id },
                                                                            '' + value.name
                                                                        );
                                                                    })
                                                                )
                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
                                                            item.childOffer.modifier[2] !== undefined ? _react3.default.createElement(
                                                                'div',
                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
                                                                item.childOffer.modifier[2].name,
                                                                _react3.default.createElement(
                                                                    'select',
                                                                    { className: 'form-control', onChange: function onChange(e) {
                                                                            _this.props.handleSelectChildOffer(e, 2, item.id);
                                                                        },
                                                                        value: item.childOffer.modValuesId2 },
                                                                    _react3.default.createElement(
                                                                        'option',
                                                                        { value: 'all' },
                                                                        _this.props.lang['store.common.choose']
                                                                    ),
                                                                    item.childOffer.modifier[2].values.map(function (value, i) {
                                                                        return _react3.default.createElement(
                                                                            'option',
                                                                            { key: value.id, value: value.id },
                                                                            '' + value.name
                                                                        );
                                                                    })
                                                                )
                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' })
                                                        )
                                                    )
                                                ),
                                                item.childOffer.nestedOffers.map(function (childItem, childIndex) {
                                                    childWeight = childItem.quantity;
                                                    if ((childItem.childOffer.unit.slug === 'kg' || childItem.childOffer.unit.slug === 'mg') && childItem.weight && childItem.weight > 0 && childItem.quantity > 0) {
                                                        childWeight = childItem.weight * childItem.quantity;
                                                        childWeight = childWeight.toFixed(3);
                                                        if (childItem.weight < 0.01 && childItem.quantity < 1 || childItem.weight < 1 && childItem.quantity < 0.01) {
                                                            childWeight = childItem.weight * 1;
                                                        }
                                                        if (childItem.weight < 0.1 && childItem.quantity < 0.1) {
                                                            childWeight = childItem.weight * 1;
                                                        }
                                                    }
                                                    if (childItem.quantity > 0 && childItem.is_quantity_change !== true) {
                                                        return _react3.default.createElement(
                                                            'tr',
                                                            null,
                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: { width: '70%', padding: '5px' } },
                                                                childItem.childOffer.name,
                                                                ' ',
                                                                childItem.childOffer.modOption ? '(' + childItem.childOffer.modOption.name + ')' : ''
                                                            ),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { colSpan: '2', style: {
                                                                        width: '25%',
                                                                        padding: '5px',
                                                                        textAlign: 'center'
                                                                    } },
                                                                childWeight,
                                                                ' ',
                                                                _this.props.translations[childItem.childOffer.unit.title_lang_data]
                                                            )
                                                        );
                                                    } else if (childItem.is_quantity_change === true) {
                                                        // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
                                                        var _maxValue2 = childItem.hasOwnProperty('quantity_max') && childItem.quantity_max > 0 ? +childItem.quantity_max : ModifierModalView.MaxValue;
                                                        var _minValue2 = childItem.hasOwnProperty('quantity_min') && childItem.quantity_min > 0 ? +childItem.quantity_min : 0;
                                                        // определяем шаг изменения
                                                        var _step2 = childItem.stepQuantity ? childItem.stepQuantity : 1;
                                                        var _classPlus2 = _step2 + childItem.quantity > _maxValue2 ? 'plus _disabled' : 'plus';
                                                        var _classMinus2 = childItem.quantity - _step2 < _minValue2 ? 'minus _disabled' : 'minus';
                                                        return _react3.default.createElement(
                                                            'tr',
                                                            null,
                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: { width: '70%', padding: '5px' } },
                                                                childItem.childOffer.name,
                                                                ' ',
                                                                childItem.modOption ? '(' + childItem.modOption.name + ')' : ''
                                                            ),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: {
                                                                        width: '15%',
                                                                        padding: '5px',
                                                                        textAlign: 'center'
                                                                    } },
                                                                _react3.default.createElement(
                                                                    'div',
                                                                    { style: { transform: 'scale(0.8 , 0.8)' }, className: 'le-quantity inline' },
                                                                    _react3.default.createElement('a', { className: _classMinus2, onClick: function onClick(e) {
                                                                            _this.props.onClickMinusChildNested(e, item.id, childItem.id);
                                                                        } }),
                                                                    _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: childWeight, style: { width: '100px' } }),
                                                                    _react3.default.createElement('a', { className: _classPlus2, onClick: function onClick(e) {
                                                                            _this.props.onClickPlusChildNested(e, item.id, childItem.id);
                                                                        } })
                                                                )
                                                            ),
                                                            _react3.default.createElement(
                                                                'td',
                                                                { style: { width: '10%' } },
                                                                _react3.default.createElement(
                                                                    'div',
                                                                    { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
                                                                    _react3.default.createElement(
                                                                        'b',
                                                                        null,
                                                                        _this.props.translations[childItem.childOffer.unit.title_lang_data]
                                                                    )
                                                                )
                                                            )
                                                        );
                                                    }
                                                }),
                                                _react3.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react3.default.createElement('td', null),
                                                    _react3.default.createElement('td', null),
                                                    _react3.default.createElement(
                                                        'td',
                                                        { colSpan: 2, style: {
                                                                width: '25%',
                                                                padding: '5px',
                                                                textAlign: 'center'
                                                            } },
                                                        _react3.default.createElement(
                                                            'b',
                                                            null,
                                                            weight,
                                                            ' ',
                                                            _this.props.translations[item.childOffer.unit.title_lang_data]
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                );
                            }
                        })
                    )
                )
            );
        };

        _this.renderListNested = function () {
            var weight = 0;
            var childWeight = 0;
            return _react3.default.createElement(
                'div',
                { className: 'no-margin col-xs-12 col-sn-12 col-md-12', style: { paddingTop: '10px' } },
                _react3.default.createElement(
                    'table',
                    { style: { width: '100%' } },
                    _react3.default.createElement(
                        'tbody',
                        null,
                        _react3.default.createElement(
                            'tr',
                            { style: { background: '#E0E0E0' } },
                            _react3.default.createElement(
                                'th',
                                { style: { width: '5%', padding: '5px' } },
                                '#'
                            ),
                            _react3.default.createElement(
                                'th',
                                { style: { width: '70%', padding: '5px' } },
                                _this.props.lang['store.short_description.component_title']
                            ),
                            _react3.default.createElement(
                                'th',
                                { style: { width: '15%', padding: '5px', textAlign: 'center' } },
                                _this.props.lang['store.short_description.quantity']
                            ),
                            _react3.default.createElement('th', { style: { width: '10%' } })
                        ),
                        _this.props.listNested.map(function (item, index) {
                            weight = item.quantity;
                            if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0 && item.quantity > 0) {
                                weight = item.weight * item.quantity;
                                weight = weight.toFixed(3);
                                if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
                                    weight = item.weight * 1;
                                }
                                if (item.weight < 0.1 && item.quantity < 0.1) {
                                    weight = item.weight * 1;
                                }
                            }
                            // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
                            var maxValue = item.hasOwnProperty('quantity_max') && item.quantity_max > 0 ? +item.quantity_max : ModifierModalView.MaxValue;
                            var minValue = item.hasOwnProperty('quantity_min') && item.quantity_min > 0 ? +item.quantity_min : 0;
                            // определяем шаг изменения
                            var step = item.stepQuantity ? item.stepQuantity : 1;
                            var classPlus = item.quantity + step > maxValue ? 'plus _disabled' : 'plus';
                            var classMinus = item.quantity - step < minValue ? 'minus _disabled' : 'minus';
                            var paddingLeft = '0px';
                            if (item.level > 1) {
                                paddingLeft = (item.level - 1) * 30 + 'px';
                            }
                            if (item.quantity > 0 && item.is_quantity_change !== true) {
                                return _react3.default.createElement(
                                    'tr',
                                    null,
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '5%', padding: '5px' } },
                                        item.level === 1 ? _react3.default.createElement(
                                            'b',
                                            null,
                                            index + 1
                                        ) : null
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '70%', padding: '5px' } },
                                        _react3.default.createElement(
                                            'div',
                                            { style: {
                                                    paddingLeft: paddingLeft,
                                                    fontWeight: item.childOffer.type_id == 5 ? 'bold' : 'normal'
                                                } },
                                            item.childOffer.name,
                                            ' ',
                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { colSpan: 2, style: {
                                                width: '25%',
                                                padding: '5px',
                                                textAlign: 'center'
                                            } },
                                        _react3.default.createElement(
                                            'b',
                                            null,
                                            weight,
                                            ' ',
                                            _this.props.translations[item.childOffer.unit.title_lang_data]
                                        )
                                    )
                                );
                            } else if (item.is_quantity_change) {
                                return _react3.default.createElement(
                                    'tr',
                                    null,
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '5%', padding: '5px' } },
                                        item.level === 1 ? _react3.default.createElement(
                                            'b',
                                            null,
                                            index + 1
                                        ) : null
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '70%', padding: '5px' } },
                                        _react3.default.createElement(
                                            'div',
                                            { style: {
                                                    paddingLeft: paddingLeft,
                                                    fontWeight: item.childOffer.type_id == 5 ? 'bold' : 'normal'
                                                } },
                                            item.childOffer.name,
                                            ' ',
                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: {
                                                width: '15%',
                                                padding: '5px',
                                                textAlign: 'center'
                                            } },
                                        _react3.default.createElement(
                                            'div',
                                            { style: { transform: 'scale(0.9 , 0.9)' }, className: 'le-quantity inline' },
                                            _react3.default.createElement('a', { className: classMinus, onClick: function onClick(e) {
                                                    _this.props.onClickMinusNested(e, item.id);
                                                } }),
                                            _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: weight, style: { width: '100px' } }),
                                            _react3.default.createElement('a', { className: classPlus, onClick: function onClick(e) {
                                                    _this.props.onClickPlusNested(e, item.id);
                                                } })
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'td',
                                        { style: { width: '10%' } },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
                                            _react3.default.createElement(
                                                'b',
                                                null,
                                                _this.props.translations[item.childOffer.unit.title_lang_data]
                                            )
                                        )
                                    )
                                );
                            }
                        })
                    )
                )
            );
        };

        _this.state = {
            countForSendBasket: props.count
        };
        return _this;
    }

    (0, _createClass3.default)(ModifierModalView, [{
        key: 'getRemainder',
        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
            var _this2 = this;

            if (nestedOffer.childOffer === null) {
                return null;
            }
            if (nestedOffer.quantity > 0) {
                var quantity = void 0;
                var quantityTechCard = void 0;
                quantity = nestedOffer.quantity;
                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
                            return modifier;
                        }
                        return mod;
                    }, null);
                }
                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.type_id === 5) {
                    nestedOffer.childOffer.remainder = [];
                    nestedOffer.childOffer.storable = false;
                    quantity = nestedOffer.quantity * quantityParent;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                product_detail = _props.product_detail,
                lang = _props.lang,
                currency = _props.currency,
                categories = product_detail.categories,
                id_yml = product_detail.id_yml,
                storable = product_detail.storable,
                storage_strict = product_detail.storage_strict,
                seo = product_detail.seo,
                vendor = '',
                old_price = void 0,
                price = 0,
                available = lang['store.modifier_modal.out_of_stock'],
                child_offers = '',
                add_to_cart = '';

            var seoH1 = product_detail.name;
            if (product_detail.old_price) {
                old_price = _react3.default.createElement(
                    'div',
                    { className: 'price-prev' },
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: product_detail.old_price,
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value
                    })
                );
            }
            if (product_detail.vendor) {
                vendor = product_detail.vendor;
            }

            // округляем число до сотых
            if (product_detail.price) {
                price = parseFloat(product_detail.price);
            }

            if (product_detail.available) {
                available = lang['store.modifier_modal.in_stock'];
            }
            if (product_detail.type_id === 5) {
                product_detail.storable = false;
                product_detail.remainder = [];
                var quantityTechCard = 1;
                var priceComponent = 0;
                var modifierComponent = null;
                var storableComponent = false;
                var modifierComponentTwo = null;
                product_detail.nestedOffers.forEach(function (nestedOffer) {
                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
                        modifierComponent = null;
                        if (nestedOffer.childOffer.type_id === 5) {
                            nestedOffer.childOffer.remainder = [];
                            nestedOffer.childOffer.storable = false;
                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                _this3.getRemainder(nestedOfferTwo, nestedOffer.quantity, product_detail);
                            });
                        } else {
                            _this3.getRemainder(nestedOffer, quantityTechCard, product_detail);
                        }
                    }
                });
                price = parseFloat(product_detail.price * this.state.countForSendBasket);
                if (product_detail.modifier_option_id !== undefined) {
                    product_detail.modifier_option.storable = product_detail.storable;
                    product_detail.modifier_option.remainder[0] = product_detail.remainder[0];
                }
            }

            if (product_detail.modifier_option_id && product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict && (product_detail.modifier_option.remainder[0] && product_detail.modifier_option.remainder[0].quantity <= 0 || product_detail.modifier_option.remainder.length === 0)) {
                add_to_cart = _react3.default.createElement(
                    'p',
                    { className: 'no_good' },
                    lang['store.add_to_cart.product_out_of_stock']
                );
            } else {
                if (product_detail.modifier_option_id && product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict) {
                    add_to_cart = _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(_components2.QuantityProduct, {
                            value: this.state.countForSendBasket,
                            checkValue: product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict && product_detail.modifier_option.remainder[0] ? true : false,
                            checkCount: product_detail.modifier_option.remainder[0] !== undefined ? product_detail.modifier_option.remainder[0].quantity : null,
                            callback: function callback(newCount) {
                                _this3.setState({ countForSendBasket: newCount });
                            } }),
                        product_detail.modifier_option_id && product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict && product_detail.modifier_option.remainder[0] && product_detail.modifier_option.remainder[0].quantity < this.state.countForSendBasket ? _react3.default.createElement('p', { className: 'no_good' }) : _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart-modal', className: ['huge'], product: product_detail,
                            count: this.state.countForSendBasket, isModal: true,
                            close: this.props.closeModal })
                    );
                } else {
                    add_to_cart = _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(_components2.QuantityProduct, {
                            value: this.state.countForSendBasket,
                            checkValue: product_detail.storable && product_detail.remainder[0] ? true : false,
                            checkCount: product_detail.remainder[0] !== undefined ? product_detail.remainder[0].quantity : null,
                            callback: function callback(newCount) {
                                _this3.setState({ countForSendBasket: newCount });
                            } }),
                        product_detail.modifier_option_id && product_detail.storable && product_detail.storage_strict && product_detail.remainder[0] && product_detail.remainder[0].quantity < this.state.countForSendBasket ? _react3.default.createElement('p', { className: 'no_good' }) : _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart-modal', className: ['huge'], product: product_detail,
                            count: this.state.countForSendBasket, isModal: true,
                            close: this.props.closeModal })
                    );
                }
            }
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'title' },
                    _react3.default.createElement(
                        'h4',
                        null,
                        seoH1
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'brand' },
                    vendor
                ),
                _react3.default.createElement(
                    'div',
                    { id: 'single-product' },
                    _react3.default.createElement(
                        'div',
                        { className: 'body-holder' },
                        _react3.default.createElement(
                            'div',
                            { className: 'body' },
                            product_detail.modifier_option_id || product_detail.type_id === 5 ? _react3.default.createElement(_components2.ProductWishIcon, { product: product_detail, isModal: true, close: this.props.closeModal }) : null,
                            this.renderModSelect(),
                            product_detail.type_id === 5 ? this.renderListNested() : null,
                            _react3.default.createElement(
                                'div',
                                { className: 'prices', style: { fontSize: '40px', fontWeight: '700', color: '@black' } },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'price-current' },
                                    _react3.default.createElement(_components2.MoneyValue, {
                                        value: price,
                                        icon: currency.icon,
                                        iconAfterValue: currency.icon_after_value
                                    })
                                ),
                                old_price
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'qnt-holder-modal' },
                                add_to_cart
                            )
                        )
                    )
                )
            );
        }
    }]);
    return ModifierModalView;
}(_react2.Component), _class2.propTypes = {
    lang: _react2.PropTypes.object.isRequired,
    currency: _react2.PropTypes.object.isRequired
}, _class2.MaxValue = 99999999999999, _temp)) || _class));

exports.default = ModifierModalView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/ModifierModal/default/ModifierModalView.jsx
// module id = 1618
// module chunks = 0